const FAQ_EN = require('./Faq_En').FAQ;
const FAQ_HE = require('./Faq_He').FAQ;

const FAQ_WONDER_EN = require('./Faq_Wonder_En').FAQ;
const FAQ_WONDER_HE = require('./Faq_Wonder_He').FAQ;

const FAQ_ELAL_EN = require('./Faq_Elal_En').FAQ;
const FAQ_ELAL_HE = require('./Faq_Elal_He').FAQ;

const FAQ_HTZ_EN = require('./Faq_HTZ_En').FAQ;
const FAQ_HTZ_HE = require('./Faq_HTZ_He').FAQ;

const FAQ_GCASH_EN = require('./Faq_GCash_En').FAQ;

const FAQ_LETSTAY_EN = require('./Faq_LetStay_En').FAQ;
const FAQ_LETSTAY_HE = require('./Faq_LetStay_He').FAQ;

const FAQ_AIRHAIFA_EN = require('./Faq_AirHaifa_En').FAQ;
const FAQ_AIRHAIFA_HE = require('./Faq_AirHaifa_He').FAQ;

const LTR = 'ltr';
const RTL = 'rtl';

const SUPPORTED_LANGUAGES = {
    EN: 'en',
    HE: 'he',
};

const SUPPORTED_LANGUAGE_CODES = Object.values(SUPPORTED_LANGUAGES);

const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES.EN;

function normalizeLanguage(language) {
    return typeof language === 'string' ? language.trim().toLowerCase() : '';
}

function isSupportedLanguage(language) {
    return SUPPORTED_LANGUAGE_CODES.includes(normalizeLanguage(language));
}

function resolveSupportedLanguage(...candidates) {
    const supported = candidates.find(isSupportedLanguage);
    return supported ? normalizeLanguage(supported) : DEFAULT_LANGUAGE;
}

const LANGUAGES = [
    { language: SUPPORTED_LANGUAGES.EN, display: 'English' },
    { language: SUPPORTED_LANGUAGES.HE, display: 'עברית' },
];

const TRANSLATION_ENGINES = {
    GOOGLE: 'google',
    OPENAI: 'openai',
};

const TRANSLATION_ENV = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
    SERVER: 'server',
};

// Shared map for hotel info translatable fields
const HOTEL_INFO_FIELDS = {
    ABOUT: 'about',
    AMENITIES: 'amenities',
    EXTRA_INFORMATION: 'extra_information',
    SUPPLIER_TERMS: 'supplier_terms',
};

module.exports = {
    LTR,
    RTL,
    SUPPORTED_LANGUAGES,
    SUPPORTED_LANGUAGE_CODES,
    DEFAULT_LANGUAGE,
    normalizeLanguage,
    isSupportedLanguage,
    resolveSupportedLanguage,
    LANGUAGES,
    HOTEL_INFO_FIELDS,
    FAQ_EN,
    FAQ_HE,
    FAQ_WONDER_EN,
    FAQ_WONDER_HE,
    FAQ_ELAL_EN,
    FAQ_ELAL_HE,
    FAQ_HTZ_EN,
    FAQ_HTZ_HE,
    FAQ_GCASH_EN,
    TRANSLATION_ENV,
    FAQ_LETSTAY_EN,
    FAQ_LETSTAY_HE,
    FAQ_AIRHAIFA_EN,
    FAQ_AIRHAIFA_HE,
    TRANSLATION_ENGINES,
};
